import { deployment } from './deployment';

/* ══════════════════════════════════════════════════════════════════════════
 * Backend (CMS API) base URL — single source of truth.
 *
 * On a public-domain deployment this is the SAME-ORIGIN proxy path from the
 * deployment mapping (`/merch-api` — no CORS, no preflight, reuses the page's
 * connection); everywhere else (legacy host, dev) the build-time
 * REACT_APP_CMS_API_URL applies, with the historical default. All API callers
 * import this instead of reading process.env inline.
 * ══════════════════════════════════════════════════════════════════════════ */

export const CMS_API_URL =
  (deployment && deployment.apiBase) ||
  process.env.REACT_APP_CMS_API_URL ||
  'https://clothes.loc';

export default CMS_API_URL;
